<template>
    <div class="chat-system-component">

        <v-btn
            text
            color="primary"
            fixed
            right
            bottom

        >
            <v-col class="mr-10 text-right font-family-1">
                <strong>¿Necesitas Ayuda?</strong>
                <p class="caption font-family-1 text-capitalize font-italic">inicia un chat ahora</p>
            </v-col>
        </v-btn>
        <v-btn
                color="#FEB22A"
                dark
                fixed
                right
                bottom
                fab
                size="90"
        >
            <v-icon>mdi-help</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: 'ChatSystemComponent',
        data() {
            return {}
        }
    }
</script>